import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { message } from "antd";
import { useFormik } from 'formik'
import * as Yup from "yup";
import { sendNotification } from '../../Web Apis/Apis';

function SendNotification({ sendModalOpen, setSendModalOpen, action, setAction }) {
    const [open, setOpen] = useState(sendModalOpen)
    const [loading, setLoading] = useState(false)

    const handleCloseModal = () => {
        setOpen(false)
        setSendModalOpen(false)
    }

    const formik = useFormik({
        initialValues: {
            title: "",
            body: ""
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Title is required").trim(),
            body: Yup.string().required("Body is required").trim()
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)
                // const data = new FormData()
                // if (values.title) data.append("title", values.occassionName)
                // if (values.occassionImage) data.append("occasionImage", values.occassionImage)
                const response = await sendNotification({...values})
                if(response?.data?.success){
                    message.success(response?.data?.message)
                    resetForm()
                    setOpen()
                    setSendModalOpen(false)
                    setAction(!action)
                }
            } catch (error) {
                console.log("Error while creating admin", error.message)
                message.error(error?.response?.data?.message || "Error while creating admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }

        }
    })



    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-2xl shadow-lg w-[700px] h-[600px] overflow-y-auto">

                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Send Notification
                </h3>

                <form onSubmit={formik.handleSubmit} className='p-8'>

                    <div className="w-full">
                        <label className="block mb-1 mt-8 text-xl font-bold">Title</label>
                        <input
                            type="text"
                            name="title"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.title}
                            placeholder='Enter title'
                        />
                        {formik.touched.title && formik.errors.title && (
                            <p className="text-red-600 ml-2">{formik.errors.title}</p>
                        )}
                    </div>

                    <div className="w-full">
                        <label className="block mb-1 mt-8 text-xl font-bold">Body</label>
                        <textarea
                            type="text"
                            rows={4}
                            name="body"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.body}
                            placeholder='Enter notification content'
                        />
                        {formik.touched.body && formik.errors.body && (
                            <p className="text-red-600 ml-2">{formik.errors.body}</p>
                        )}
                    </div>
                    <div className="flex justify-center gap-6 mt-6">
                        <button
                            onClick={handleCloseModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            Send
                        </button>
                    </div>
                    {loading && <Loader />}
                </form>

            </div>
        </div>
    )
}

export default SendNotification